










































































import {Vue, Component, Prop} from 'vue-property-decorator';

@Component
export default class ProductInquiryOrderInfo extends Vue {
  @Prop({
    required: false,
    type: Object,
  })
  private readonly data!: {[propName: string]: any};

  private get dataLength(): boolean {
    if (!this.data || Object.keys(this.data).length === 0) {
      return false;
    } else {
      return this.data.shippingNo !== -1;
    }
  }
}
